import React, { useState } from 'react'
import cx from 'classnames'
import { View, Text, Button } from '@gopeerproject/ui-kit'
import { useStyleSheet, createStyleSheet } from '@gopeerproject/ui-kit'
import { MemberControls as MC } from '@constants'
import {
  useClassroomQuery,
  useClassroomState,
  useMemberAdmissionAction,
  useMemberControls
} from '../../hooks'
import { Icon } from '../../../UI'

export const MemberWaitingBanner = () => {
  const styles = useStyleSheet(getStyles)
  const [dismissed, setDismissed] = useState([])

  const { isSidebarOpen, sidebarPanel } = useClassroomState()

  const { data: classroom } = useClassroomQuery()

  const {
    data: { participants: members }
  } = useMemberControls()

  const { mutateAsync: updateMemberStatus } = useMemberAdmissionAction()

  const waitlist = members
    .filter((member) => member.status === MC.WaitingRoomStatus.WAITING)
    .map((member) => {
      return {
        id: member.id,
        ...classroom.participants[member.id]
      }
    })

  if (!waitlist.length) return null
  if (isSidebarOpen && sidebarPanel === 'member_controls') return null

  const participant = waitlist.find((p) => !dismissed.includes(p.id))

  if (!participant) return null

  return (
    <div className={cx('gp-new-classroom-ConnectionBanner is-info')}>
      <Text type='body' size='md' style={styles.text}>
        {participant.name} is waiting to join the classroom.
      </Text>
      <View style={styles.actionsContainer}>
        <Button
          leftIcon='checkmark'
          size='xs'
          text='Admit'
          centered
          onPress={() => {
            updateMemberStatus({
              participantId: participant.id,
              status: MC.WaitingRoomStatus.ADMITTED
            })
          }}
          // size='md'
          type='tertiary'
          accent='white'
        />

        {/* <Button
          leftIcon='dismiss'
          size='xs'
          text='Reject'
          centered
          onPress={() => {
            updateMemberStatus({
              participantId: participant.id,
              status: MC.WaitingRoomStatus.REJECTED
            })
          }}
          // size='md'
          type='tertiary'
          accent='white'
        /> */}
      </View>
      <div className='gp-ExpirationBanner-control-container'>
        <button onClick={() => setDismissed((d) => [...d, participant.id])}>
          <Icon name='close' />
        </button>
      </div>
    </div>
  )
}

const getStyles = createStyleSheet(({ size }) => ({
  actionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: size.C,
    marginLeft: size.C
  }
}))
